<div
  class="bb-logo"
  [ngClass]="{
    'bb-logo--emblem': isEmblem,
    'bb-logo--inverse': isInverse
  }"
></div>
